export default [
  '开始',
  '初始化',
  'created app.vew',
  'detail render',
  'detail render fundData',
  '图表：render开始',
  'detail render 4',
  '图表：刷新开始',
  'requset FundMNYieldDiagram s',
  'requset FundMNYieldDiagram e',
  '图表：刷新结束',
  '图表：render结束',
  'detail render 5',
  'detail render over',
  '成本线 买卖点 请求开始',
  '成本线 买卖点 请求完毕',
  'navClick',
  'detail render catch',
  '获取接口缓存开始',
  '获取接口离线缓存',
  '开始请求接口',
  '接口返回',
  '返回数据',
  'fund.request get FundVPageAcc start',
  'fund.request get FundVPageAcc end',
  'fund.request post FundVPageAcc start',
  'fund.request post FundVPageAcc end',
  'axios get FundVPageAcc start',
  'axios get FundVPageAcc end',
  'axios post FundVPageAcc start',
  'axios post FundVPageAcc end',
  '写入缓存',
  '获取缓存字符串',
  '解析缓存字符串',
  '查找缓存',
  '图表接口请求结束',
  '限制长度在500内',
  '基金指定的指数列表',
  '格式化数据',
  '绘制图表',
  'drawChart-绘制走势图数据',
  'drawChart-轴线比例',
  'drawChart-tooltip',
  'drawChart-axis value',
  'drawChart-axis date',
  'drawChart-画买卖点',
  'drawChart-画变动点',
  'drawChart-画走势线',
  'drawChart-设置极点提示',
  'drawChart-chart.render',
  '判断是否有用户买卖信息',
];
